import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { HttpClient } from "@angular/common/http";

// AR-24  Send-questionnaire popup (opened from the today-list row and the
// patient-history screen). Self-contained: talks to this app's own backend
// proxy (/api/questionnaires[/send]). Prefills phone + auto-selects the
// questionnaire matching the exam type; unknown exam => nothing preselected.
@Component({
  selector: "app-send-questionnaire",
  templateUrl: "./send-questionnaire.component.html",
  styleUrls: ["./send-questionnaire.component.scss"],
  standalone: false,
})
export class SendQuestionnaireComponent implements OnInit {
  @Input() patient: any = {};
  @Output() closed = new EventEmitter<void>();

  questionnaires: any[] = [];
  loading = true;
  loadError = false;

  phone = "";
  selectedId: number | null = null;

  sending = false;
  sent = false;
  error: any = null;
  errorDetail: string = null;

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    const p = this.patient || {};
    this.phone = p.Mobile || p.Phone || p.mobile || p.phone || "";
    this.http.get("/api/questionnaires").subscribe({
      next: (data: any) => {
        this.loading = false;
        this.questionnaires = (data && data.questionnaires) || [];
        this.autoSelect();
      },
      error: () => {
        this.loading = false;
        this.loadError = true;
      },
    });
  }

  private norm(s: any): string {
    return (s == null ? "" : String(s)).trim().toLowerCase();
  }

  examCode(): string {
    const p = this.patient || {};
    return p.ExamCode || p.examCode || p.ExamType || p.examType || "";
  }

  private autoSelect(): void {
    const code = this.norm(this.examCode());
    if (!code) return;
    const match = this.questionnaires.find((q) =>
      (q.examNames || []).some((n: any) => this.norm(n) === code)
    );
    if (match) this.selectedId = match.AutoIndex;
  }

  send(): void {
    if (!this.selectedId || !this.phone) return;
    this.sending = true;
    this.error = null;
    const p = this.patient || {};
    const payload = {
      mobile: this.phone,
      questionnaireId: this.selectedId,
      PID: p.PID != null ? p.PID : null,
      patientId: p.ID != null ? p.ID : (p.patientId != null ? p.patientId : null),
      awlId: p.AWLID != null ? p.AWLID : (p.awlId != null ? p.awlId : null),
      appointmentId: p.appointmentId != null ? p.appointmentId : null,
      examCode: this.examCode(),
    };
    this.http.post("/api/questionnaires/send", payload).subscribe({
      next: () => {
        this.sending = false;
        this.sent = true;
      },
      error: (e: any) => {
        this.sending = false;
        this.error = e;
        this.errorDetail = e && e.error && e.error.error ? e.error.error : null;
      },
    });
  }

  close(): void {
    this.closed.emit();
  }
}
